import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onCatalogOptionClick"];
let _ = t => t,
  _t;
import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H4 } from 'foundations-components/transitional/components/H4';
import { HR } from 'foundations-components/transitional/components/HR';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { ChatTextInput } from 'academy-common-lib/features/search/components/ChatTextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUserInfo } from '../../accounts/accountsQueries';
import I18n from 'I18n';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
// @ts-expect-error bender-url module not typed
import heroImage from 'bender-url!../../../../images/pngs/homepage-hero-assistant.png';
import { useNavPageHandlers } from '../../navigation';
import { ACCatalogFilterButton } from 'academy-navigation-lib/components/ACCatalog/ACCatalogFilterButton';
import { ACCatalogMultiSelect } from 'academy-navigation-lib/components/ACCatalog/ACCatalogMultiSelect';
import { ACSearchInput } from 'academy-navigation-lib/components/ACSearchInput/ACSearchInput';
import useNavigate from '../../../hooks/useNavigate';
import { ACADEMY_ASSISTANT_URL_FRAGMENT } from '../../../constants/Navigation';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { useSearchPlaceholder } from '../searchHooks';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeroImage = styledWithTheme.img(_t || (_t = _`
  block-size: 100%;
  display: block;
  inline-size: 100%;
  object-fit: cover;
  object-position: top center;
`));
export const AcademyAssistantHomeSearchPrompt = () => {
  var _userInfo$user;
  const {
    isMobile,
    isTablet,
    isDesktop
  } = useMediaQuery();
  const {
    userInfo
  } = useUserInfo();
  const firstName = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.firstName;
  const navigate = useNavigate();
  const [tab, setTab] = useState('assistant');
  const [assistantInput, setAssistantInput] = useState('');
  const searchPlaceholder = useSearchPlaceholder();
  const _useNavPageHandlers = useNavPageHandlers({
      appearsIn: 'academy-assistant-home-search-prompt'
    }),
    {
      onCatalogOptionClick
    } = _useNavPageHandlers,
    searchInputHandlers = _objectWithoutPropertiesLoose(_useNavPageHandlers, _excluded);
  const submitAssistantPrompt = useCallback(() => {
    const trimmed = assistantInput.trim();
    if (!trimmed) {
      return;
    }
    navigate({
      pathname: ACADEMY_ASSISTANT_URL_FRAGMENT,
      search: '',
      hash: '',
      state: {
        initialPrompt: trimmed
      }
    });
  }, [assistantInput, navigate]);
  const onAssistantChatInputChanged = useCallback(e => {
    setAssistantInput(e.target.value);
  }, []);
  const onAssistantKeyDown = useCallback(e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitAssistantPrompt();
    }
  }, [submitAssistantPrompt]);
  const Header = isMobile ? H4 : H1;
  return /*#__PURE__*/_jsx(HomePageSection, {
    padding: "0",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "396px",
        gap: "1500",
        children: [/*#__PURE__*/_jsxs(Flex, {
          blockSize: "100%",
          flexBasis: 0,
          flexDirection: "column",
          flexGrow: 1,
          gap: "400",
          minInlineSize: "0",
          paddingBlockEnd: "900",
          children: [/*#__PURE__*/_jsx(Header, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.getStarted.header",
              options: {
                firstName
              }
            })
          }), /*#__PURE__*/_jsx(View, {
            minBlockSize: isMobile ? '96px' : '112px',
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "400",
              children: [/*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantWelcome"
                })
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantLearnPrompt"
                })
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            "data-onboarding-hook": "search-or-browse-topics",
            flexDirection: "column",
            flexGrow: 1,
            minBlockSize: "0",
            minInlineSize: "0",
            children: [/*#__PURE__*/_jsx(View, {
              inlineSize: "100%",
              minBlockSize: "56px",
              children: /*#__PURE__*/_jsx(Text, {
                as: "span",
                typography: isMobile || isTablet ? 'body-125' : undefined,
                children: /*#__PURE__*/_jsxs(Tabs, {
                  fill: isMobile,
                  inlineSize: "100%",
                  moreTabsRenderer: null,
                  onSelectedChange: e => {
                    const next = e.target.value;
                    if (next === 'assistant' || next === 'legacy') {
                      setTab(next);
                    }
                  },
                  selected: tab,
                  children: [/*#__PURE__*/_jsx(Tab, {
                    tabId: "assistant",
                    title: I18n.text('learningCenter.getStarted.assistantTab')
                  }), /*#__PURE__*/_jsx(Tab, {
                    tabId: "legacy",
                    title: I18n.text('learningCenter.getStarted.searchLegacyTab')
                  })]
                })
              })
            }), /*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              flexGrow: 1,
              inlineSize: "100%",
              justifyContent: "start",
              marginBlockStart: "400",
              minBlockSize: "0",
              minInlineSize: "0",
              children: tab === 'assistant' ? /*#__PURE__*/_jsx(ChatTextInput, {
                autoFocus: !isMobile,
                leadingIcon: null,
                onChatInputChanged: onAssistantChatInputChanged,
                onKeyDown: onAssistantKeyDown,
                onSend: submitAssistantPrompt,
                placeholder: I18n.text('learningCenter.getStarted.assistantPlaceholder'),
                value: assistantInput
              }) : /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                flexDirection: isMobile ? 'row-reverse' : 'row',
                gap: "400",
                inlineSize: "100%",
                children: [isMobile ? /*#__PURE__*/_jsx(ACCatalogFilterButton, {
                  onCatalogOptionClick: onCatalogOptionClick
                }) : /*#__PURE__*/_jsx(ACCatalogMultiSelect, {
                  onCatalogOptionClick: onCatalogOptionClick
                }), /*#__PURE__*/_jsx(View, {
                  blockSize: "42px",
                  flexGrow: 1,
                  maxInlineSize: "100%",
                  minInlineSize: "0",
                  position: "relative",
                  zIndex: "3",
                  children: /*#__PURE__*/_jsx(View, {
                    inlineSize: "100%",
                    position: "absolute",
                    children: /*#__PURE__*/_jsx(ACSearchInput, Object.assign({
                      placeholder: searchPlaceholder,
                      use: "on-dark"
                    }, searchInputHandlers))
                  })
                })]
              })
            })]
          })]
        }), isDesktop ? /*#__PURE__*/_jsx(Flex, {
          "aria-hidden": true,
          blockSize: "100%",
          flexBasis: 0,
          flexGrow: 1,
          flexShrink: 1,
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(View, {
            blockSize: "90%",
            borderRadius: "300",
            inlineSize: "100%",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(HeroImage, {
              alt: "",
              src: heroImage
            })
          })
        }) : null]
      }), !isMobile ? /*#__PURE__*/_jsx(HR, {
        "data-test-id": "separator",
        distance: "flush"
      }) : null]
    })
  });
};
export default AcademyAssistantHomeSearchPrompt;